import { render, staticRenderFns } from "./listagem-relatorio-cadeira.vue?vue&type=template&id=08cb8862&"
import script from "./listagem-relatorio-cadeira.vue?vue&type=script&lang=js&"
export * from "./listagem-relatorio-cadeira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports